import { useState } from "react"
import { useEffect, FC } from "react"

type Pokemon = {
  name: string
  url: string
}

type PokemonResponse = {
  count: number
  next: string
  previous: string | null
  results: Pokemon[]
}

const Pokemon: FC = () => {
  const [pokemons, setPokemons] = useState<Pokemon[]>([])

  const fetchPokemons = () => fetch('https://pokeapi.co/api/v2/pokemon')
    .then(res => {
      console.log("res", res)
      return res.json()
    })
    .then((response: PokemonResponse) => {
      setPokemons(response.results)
    })

  useEffect(() => {
    fetchPokemons()
  }, [])

  return (
    <ul>
      {pokemons.map(p => (
        <li>{p.name}</li>
      ))}
    </ul>
  )
}

export default Pokemon